import { Content } from '../../types';

export const chiangMaiPaiChiangRaiRoadAttractionsContent: Content = {
  title: "אטרקציות על אם הדרך מצ'אנג מאי לפאי ולצ'יאנג ראי",
  imageUrl:
    '/images/thailand/chiang-mai-pai-chiang-rai-road/chiang-mai-pai-chiang-rai-road-wide.jpeg',
  introduction: `הנסיעה מצ'אנג מאי צפונה, בין אם לכיוון פאי או לכיוון צ'אנג ראי, עוברת דרך נופים מרהיבים, יערות, מפלים, מערות, כפרים אתניים ואטרקציות רבות נוספות. כבישים 107, 1096 ו-1095 מציעים שלל אפשרויות טיול שאפשר לשלב בטיולי יום או כחלק מהדרך ליעדים הצפוניים.`,
  sections: [
    {
      title: 'כביש 1096 - דרך הנוף והכפרים',
      type: 'sub-headers',
      description:
        'כביש 1096 ידוע כאחד הכבישים היפים באזור הצפון, עם מגוון אטרקציות טבע ותרבות המתאימות לכל המשפחה. להלן האטרקציות המומלצות לאורך הדרך:',
      content: [
        {
          subtitle: 'חוות הסחלבים והפרפרים Bai',
          text: 'חווה מרשימה עם מגוון רחב של סחלבים צבעוניים ופרפרים אקזוטיים בסביבה טרופית יפהפייה.',
        },
        {
          subtitle: 'מפלי Mae Sa',
          text: 'סדרת מפלים מרשימה עם מסלול קצר ומסודר, בריכות טבעיות ונקודות עצירה מוצלות לפיקניק.',
        },
        {
          subtitle: 'הגנים הבוטניים המלכה סיריקיט',
          text: 'אחד מהגנים הבוטניים המרשימים בתאילנד, עם חממות ענקיות, מבחר עצום של צמחייה אקזוטית, גשרים תלויים ומצפורים פנורמיים.',
        },
        {
          subtitle: 'חוות פילים אתניות',
          text: 'באזור זה מספר חוות פילים טיפוליות, המציעות חוויות של מפגש עם פילים ללא רכיבה, כולל האכלה, רחצה ולמידה על חייהם.',
        },
        {
          subtitle: 'חוות הנחשים ומופעי חיות',
          text: 'ניתן למצוא מספר חוות המציגות מופעים עם נחשים, תנינים ובעלי חיים נוספים.',
        },
        {
          subtitle: 'בתי קפה ונוף פסטורלי',
          text: 'לאורכו של הכביש, במקביל לנהר, ישנם בתי קפה עם תצפיות מרהיבות על ההרים והעמקים הירוקים.',
        },
      ],
    },
    {
      title: 'כביש 1095 - הדרך ההררית לפאי',
      type: 'sub-headers',
      description:
        'כביש 1095 המוביל לפאי ידוע ב-762 העיקולים שלו ובנופים ההרריים המרהיבים. לאורך הדרך המתפתלת ניתן למצוא מספר אטרקציות מיוחדות:',
      content: [
        {
          subtitle: 'מפל Mok Fa',
          text: 'מפל גבוה ומרשים עם בריכה טבעית לרחצה, מוקף יער צפוף.',
        },
        {
          subtitle: 'גייזר Pong Duet Pa Pae',
          text: 'גייזר טבעי המתנשא לגובה עם מים חמים בוקעים מן האדמה. בסמוך ישנם מעיינות חמים טבעיים ונוף מרהיב.',
        },
        {
          subtitle: 'Pai Canyon (קניון פאי)',
          text: 'אזור עם שבילי הליכה על רכסים צרים ותצפיות מדהימות על הרי האזור, בעיקר בשעת השקיעה.',
        },
        {
          subtitle: 'גשר הזיכרון Ta-Pai Memorial Bridge',
          text: 'גשר עץ היסטורי שנבנה על ידי הכוחות היפנים בתקופת מלחמת העולם השנייה.',
        },
        {
          subtitle: 'הכפר הסיני Santichon Baan',
          text: 'כפר מסורתי של יוצאי סין בו ניתן לחוות את התרבות, האוכל והאדריכלות הסינית הייחודית.',
        },
        {
          subtitle: 'מפלי Pam Bok',
          text: 'מפלים קטנים הממוקמים בקניון צר עם מים צלולים ונעימים לרחצה.',
        },
        {
          subtitle: 'מעיינות חמים Hot Springs Tha Pai',
          text: 'בריכות מים חמים טבעיות בהן ניתן לטבול וליהנות מהחום המרגיע.',
        },
        {
          subtitle: 'כפרי שבטי ההרים',
          text: 'לאורך הדרך ניתן לבקר בכפרי שבטי ההרים כגון ליסו, לאהו, קארן, מונג ועוד וללמוד על אורח חייהם ותרבותם.',
        },
      ],
    },
    {
      title: "כביש 107 - הדרך לצ'אנג דאו וצ'אנג ראי",
      type: 'sub-headers',
      description:
        "כביש 107 מוביל צפונה לכיוון צ'אנג ראי ומציע מגוון אטרקציות המשלבות פעילויות אקסטרים, טבע ותרבות:",
      content: [
        {
          subtitle: 'ראפטינג על נהר Mae Taeng',
          text: 'בעונה הרטובה, הנהר מציע מסלולי ראפטינג אקסטרים עם זרמים חזקים, חווייתי במיוחד לחובבי האדרנלין.',
        },
        {
          subtitle: 'מערות Chiang Dao',
          text: 'מערכת מערות מרשימה בתוך הרים גיריים, בה ניתן לבקר בחלק מהן עצמאית או עם מדריך מקומי.',
        },
        {
          subtitle: 'דוי אנגקאנג (Doi Ang Khang)',
          text: "אזור הררי עם טרסות תה, שווקים מקומיים ונופים מרהיבים, מתאים לטיולי יום מצ'אנג מאי.",
        },
        {
          subtitle: 'כפרי שבטי ההרים',
          text: "אזור צ'אנג דאו עשיר בכפרי שבטי הרים כמו קארן ופאלונג, בהם ניתן ללמוד על תרבותם הייחודית.",
        },
      ],
    },
    {
      title: 'אטרקציות נוספות',
      type: 'sub-headers',
      description:
        "בסביבת צ'אנג מאי ישנן אטרקציות נוספות הממוקמות בכבישים אחרים, המומלצות לטיולי יום:",
      content: [
        {
          subtitle: 'מפלי Buathong (כביש 1001)',
          text: 'מפלים ייחודיים בהם ניתן לטפס על סלעים מחוספסים מבלי להחליק, חוויה מהנה לכל הגילאים.',
        },
        {
          subtitle: 'כפר המפעלים Bo Sang (מטריות, עץ, משי) (כביש 1006)',
          text: 'מפעלים אותנטיים מקומיים, בהם ניתן הן לחוות את עבודת הייצור והן להזמין מזכרות אישיות.',
        },
        {
          subtitle: 'מעיינות חמים San Kamphaeng Hot Springs (כביש 4041)',
          text: 'מעיינות חמים המתאימים לכל המשפחה, ניתן לבקר במקום במסגרת יעד נוסף ביום טיול לכפר המפעלים.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, הדרכים מצ'אנג מאי צפונה מציעות שלל חוויות טבע, תרבות והרפתקאות. בין אם אתם בדרככם לפאי, צ'אנג ראי או טיול יומי מסביב לצ'אנג מאי, מומלץ לעצור וליהנות מהמקומות הייחודיים שבדרך!`,
      type: 'text',
      isBold: true,
    },
  ],
};
